import Footer from "./components/Footer";
import Header from "./components/Header";
import AboutPage from "./components/pages/AboutPage";
import ContactPage from "./components/pages/ContactPage";
import LandingPage from "./components/pages/LandingPage";
import SzilviaPage from "./components/pages/SzilviaPage";
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router"
import ServicesPage from "./components/pages/ServicesPage";
import ReferencesPage from "./components/pages/ReferencesPage";

function App() {
  return (
    <BrowserRouter>

      <div className="App">
          <Header/>

          <Routes>
            <Route path="/contact" element={<ContactPage/>}/>
            <Route path="/references" element={<ReferencesPage/>}/>
            <Route path="/services" element={<ServicesPage/>}/>
            <Route path="/about" element={<AboutPage/>}/>
            <Route path="/szilvia" element={<SzilviaPage/>}/>
            <Route path="/" element={<LandingPage/>}/>
          {/*<LandingPage/>*/}         
          </Routes>



        <Footer/>
      </div>
    </BrowserRouter>
  );
}

export default App;
